module.exports = __webpack_public_path__ + "static/media/jamie-sparker-portrait.fb58d5a8.png";